module.exports = __webpack_public_path__ + "rotas.png?eb135189766042a960855857a8a06fa6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rotas.png
// module id = 750
// module chunks = 0